import { Components, tableCellClasses } from '../../material';

export const MuiTableCell: Components['MuiTableCell'] = {
  styleOverrides: {
    root: {
      border: 0,
      [`&.${tableCellClasses.head}`]: {
        lineHeight: 1.43,
      },
    },
  },
};
